<script lang="ts" setup>
import { PropType } from 'vue';
import { Result } from '@/models/results.model';
import { Hours } from '@/models/timesheet-day';

const { result } = defineProps({
  result: {
    type: Object as PropType<Result<Hours>>,
    required: true,
  },
});
</script>
<template>
  <li class="search-result">
    Hours
    <router-link
      :to="`/timesheet/project/${result.item.project_id}/${result.item.date}`"
      >{{ result.item.date }}
    </router-link>
    <div>
      {{ result.item.description }}
    </div>
  </li>
</template>
